import styled from 'styled-components';


export const userOptions = (params = {}) => ({
  header: params.header,
  data: params.data,
});

//  标题a
export const ModuleTitle = styled.h3`
  padding: 0.2rem 0.125rem;
  color: #FFFFFF;
  font-size: 0.8rem;
  font-weight: bold;
  .iconfont {
    font-size: 0.8rem;
    margin-right: 0.125rem;
    color: #89e5ff;
    font-weight: 400;
  }
`;
